import { render, staticRenderFns } from "./ClientShow.vue?vue&type=template&id=2b6a5956&"
import script from "./ClientShow.vue?vue&type=script&lang=js&"
export * from "./ClientShow.vue?vue&type=script&lang=js&"
import style0 from "./ClientShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports